// extracted by mini-css-extract-plugin
export default {"warning":"Delete_warning__6GpDV","label":"Delete_label__bDYrE"};